import { GroupDto2 } from "@growth-machine-llc/stridist-api-client";

export function userIsGroupOwner(group: GroupDto2, currentUserId: number): boolean {
  return group.coachId === currentUserId;
}


